import React from 'react';
import styles from './GlobalCheckbox.module.css';

interface GlobalCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  className?: string;
}

export const GlobalCheckbox: React.FC<GlobalCheckboxProps> = ({
  label,
  error,
  className,
  checked,
  onChange,
  disabled,
  ...props
}) => {
  return (
    <div className={`${styles.checkboxContainer} ${className || ''}`}>
      <label className={`${styles.checkboxLabel} ${disabled ? styles.disabled : ''}`}>
        <input
          {...props}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={styles.checkbox}
        />
        <span className={`${styles.checkboxCustom} ${checked ? styles.checked : ''} ${error ? styles.error : ''}`}>
          {checked && (
            <svg
              className={styles.checkmark}
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
        {label && <span className={styles.labelText}>{label}</span>}
      </label>
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};

GlobalCheckbox.displayName = 'GlobalCheckbox';

